import { useState, useEffect } from "react";
import "./Home.css";
import video from "../xiph0s S quiet.mp4";
import logo from "../logo3.png";

export default function Home() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="home-container">
            {isMobile ? (
                <img src={logo} alt="Logo" className="home-logo" />
            ) : (
                <video
                    className="home-video"
                    autoPlay
                    muted
                    playsInline
                >
                    <source src={video} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            )}
        </div>
    );
}